import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';
import type { ConfirmEmailBySlackTokenType } from '@/shared/types/auth';

export const useConfirmEmailBySlackTokenMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: ConfirmEmailBySlackTokenType) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async (slackToken: string) => {
      const body = {
        token: slackToken,
      };

      const response = await recallApi.confirmEmailBySlackToken({
        body,
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
